<template>
	<svg
		width="21px"
		height="17px"
		viewBox="0 0 21 17"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		alt="gallery icon"
	>
		<title>Switch to Gallery</title>
		<g
			id="Livestream"
			stroke="none"
			stroke-width="1"
			fill="none"
			fill-rule="evenodd"
		>
			<g
				id="Livestream---End-Share-Screen"
				transform="translate(-1067.000000, -22.000000)"
				:fill="fill"
			>
				<path
					d="M1076.02991,31.35 C1076.39574,31.35 1076.69231,31.6465666 1076.69231,32.0124 L1076.69231,38.3376 C1076.69231,38.7034334 1076.39574,39 1076.02991,39 L1067.6624,39 C1067.29657,39 1067,38.7034334 1067,38.3376 L1067,32.0124 C1067,31.6465666 1067.29657,31.35 1067.6624,31.35 L1076.02991,31.35 Z M1087.3376,31.35 C1087.70343,31.35 1088,31.6465666 1088,32.0124 L1088,38.3376 C1088,38.7034334 1087.70343,39 1087.3376,39 L1078.97009,39 C1078.60426,39 1078.30769,38.7034334 1078.30769,38.3376 L1078.30769,32.0124 C1078.30769,31.6465666 1078.60426,31.35 1078.97009,31.35 L1087.3376,31.35 Z M1076.02991,22 C1076.39574,22 1076.69231,22.2965666 1076.69231,22.6624 L1076.69231,28.9876 C1076.69231,29.3534334 1076.39574,29.65 1076.02991,29.65 L1067.6624,29.65 C1067.29657,29.65 1067,29.3534334 1067,28.9876 L1067,22.6624 C1067,22.2965666 1067.29657,22 1067.6624,22 L1076.02991,22 Z M1087.3376,22 C1087.70343,22 1088,22.2965666 1088,22.6624 L1088,28.9876 C1088,29.3534334 1087.70343,29.65 1087.3376,29.65 L1078.97009,29.65 C1078.60426,29.65 1078.30769,29.3534334 1078.30769,28.9876 L1078.30769,22.6624 C1078.30769,22.2965666 1078.60426,22 1078.97009,22 L1087.3376,22 Z"
					id="Combined-Shape"
				></path>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	Name: 'Grid',
	props: ['active'],

	computed: {
		fill() {
			return this.active ? '#ffffff' : '#484848'
		},
	},
}
</script>
